import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'frequency', 'time', 'weekday', 'monthday', 'custom', 'onceAt',
    'timeField', 'weekdayField', 'monthdayField', 'customField', 'onceField',
    'dedupField',
    'preview', 'output', 'onceOutput'
  ]

  connect() {
    this.compute()
  }

  updateFrequency() {
    const value = this.frequencyTarget.value
    const showTime = ['daily', 'weekdays', 'weekly', 'monthly'].includes(value)

    this.toggle(this.timeFieldTarget, showTime)
    this.toggle(this.weekdayFieldTarget, value === 'weekly')
    this.toggle(this.monthdayFieldTarget, value === 'monthly')
    this.toggle(this.customFieldTarget, value === 'custom')
    if (this.hasOnceFieldTarget) this.toggle(this.onceFieldTarget, value === 'once')
    if (this.hasDedupFieldTarget) this.toggle(this.dedupFieldTarget, value !== 'once')

    this.compute()
  }

  compute() {
    const freq = this.frequencyTarget.value
    const cron = this.buildCron()
    const onceAt = freq === 'once' && this.hasOnceAtTarget ? this.onceAtTarget.value : ''

    this.outputTarget.value = cron
    if (this.hasOnceOutputTarget) this.onceOutputTarget.value = onceAt

    this.previewTarget.textContent = this.buildPreview(freq, cron, onceAt)
  }

  buildPreview(freq, cron, onceAt) {
    if (freq === 'manual') return '(manual)'
    if (freq === 'once') return onceAt ? `uma vez em ${this.formatOnce(onceAt)}` : '(escolha data e horário)'
    return cron || '(manual)'
  }

  formatOnce(isoLocal) {
    const [date, time] = isoLocal.split('T')
    if (!date) return isoLocal
    return `${date}${time ? ' ' + time.slice(0, 5) : ''}`
  }

  buildCron() {
    const freq = this.frequencyTarget.value
    if (freq === 'manual' || freq === 'once') return ''
    if (freq === 'custom') return (this.hasCustomTarget ? this.customTarget.value : '').trim()

    const time = (this.hasTimeTarget && this.timeTarget.value) || '10:00'
    const [hh, mm] = time.split(':').map(s => parseInt(s, 10))
    const hour = Number.isFinite(hh) ? hh : 10
    const minute = Number.isFinite(mm) ? mm : 0

    switch (freq) {
      case 'daily':
        return `${minute} ${hour} * * *`
      case 'weekdays':
        return `${minute} ${hour} * * 1-5`
      case 'weekly': {
        const dow = this.checkedWeekday() || '1'
        return `${minute} ${hour} * * ${dow}`
      }
      case 'monthly': {
        const day = (this.hasMonthdayTarget && this.monthdayTarget.value) || '1'
        return `${minute} ${hour} ${day} * *`
      }
      default:
        return ''
    }
  }

  checkedWeekday() {
    const checked = this.weekdayTargets.find(r => r.checked)
    return checked?.value
  }

  toggle(el, show) {
    if (!el) return
    el.classList.toggle('hidden', !show)
  }
}
